import React from "react"
import {IFilterInput} from "../IFilterBase";
import {API_FILTER_TYPE} from "../../../model/constants/ApiConstant";
import {Select as AntdSelect} from "antd";
import LocaleText from "../../../components/app/settings/dictionary/LocaleText";
import {isFilterNested} from "../../../model/interface/api/IRestServiceFilters";


interface IState {

}

interface IProps extends IFilterInput {
    onPressEnter?: () => void
}

class Select extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {field, onChange, onPressEnter, selected} = this.props
        const search = Object.values(selected[0]?.children || {}).map(s => isFilterNested(s) ? '' : s.value + '')

        return (
            <AntdSelect className={'w-100'} mode={'multiple'} onKeyDown={e => e.key === 'Enter' ? onPressEnter?.() : undefined} value={search} autoFocus={true} onChange={e => onChange(Array.isArray(e) ? [{type: API_FILTER_TYPE.OR, name: field.name, children: Object.fromEntries(e.map((v, index) => ['i' + index, {value: v, type: API_FILTER_TYPE.LIKE, field: field.name}]))}] : [{value: e, type: API_FILTER_TYPE.LIKE, name: field.name}])}>
                {field.options.selectOptions?.map((option, i) => (
                    <AntdSelect.Option key={i} value={option}><LocaleText code={option}/></AntdSelect.Option>
                ))}
            </AntdSelect>
        )
    }
}

export default Select